import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Logo, Btn, Input, Select } from '../../components/UI';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';

const PLANS = [{ value: '', label: 'Select Plan' }, { value: '1', label: 'Starter — ₹499/mo' }, { value: '2', label: 'Growth — ₹999/mo' }, { value: '3', label: 'Pro — ₹1,999/mo' }, { value: '4', label: 'Enterprise — ₹4,999/mo' }];
const STATES = ['Tamil Nadu','Andhra Pradesh','Karnataka','Kerala','Maharashtra','Delhi','Gujarat','Rajasthan','Uttar Pradesh','West Bengal','Other','Outside India'].map(s => ({ value: s, label: s }));
const PRICES = { 1:{inr_m:499,inr_y:4790,usd_m:8,usd_y:77}, 2:{inr_m:999,inr_y:9590,usd_m:14,usd_y:135}, 3:{inr_m:1999,inr_y:19190,usd_m:26,usd_y:250}, 4:{inr_m:4999,inr_y:47990,usd_m:62,usd_y:596} };

export default function Register() {
  const [form, setForm] = useState({ name:'', company_name:'', email:'', phone:'', address:'', state:'Tamil Nadu', gstin:'', currency:'INR', plan_id:'', billing_cycle:'monthly', password:'', confirm_password:'' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const getPrice = () => {
    if (!form.plan_id) return null;
    const p = PRICES[form.plan_id];
    const sym = form.currency === 'INR' ? '₹' : '$';
    const amount = form.currency === 'INR' ? (form.billing_cycle === 'yearly' ? p.inr_y : p.inr_m) : (form.billing_cycle === 'yearly' ? p.usd_y : p.usd_m);
    let gst = 0, gstLabel = '';
    if (form.currency === 'INR') {
      if (form.state === 'Tamil Nadu') { gst = amount * 0.18; gstLabel = 'CGST 9% + SGST 9%'; }
      else if (form.state !== 'Outside India') { gst = amount * 0.18; gstLabel = 'IGST 18%'; }
    }
    return { sym, amount, gst, gstLabel, total: amount + gst };
  };
  const price = getPrice();

  const handleSubmit = async e => {
    e.preventDefault(); setError(''); 
    if (form.password !== form.confirm_password) { setError('Passwords do not match'); return; }
    if (form.password.length < 6) { setError('Password must be at least 6 characters'); return; }
    setLoading(true);
    try {
      const { data } = await api.post('/api/auth/register', {
        name: form.name, company_name: form.company_name, email: form.email,
        phone: form.phone, address: form.address, state: form.state,
        country: form.state === 'Outside India' ? 'International' : 'India',
        gstin: form.gstin, currency: form.currency, plan_id: form.plan_id,
        billing_cycle: form.billing_cycle, password: form.password
      });
      if (data.success) {
        login(data.token, data.user);
        localStorage.setItem('msreach_reg_plan', form.plan_id);
        localStorage.setItem('msreach_reg_billing', form.billing_cycle);
        localStorage.setItem('msreach_reg_currency', form.currency);
        navigate('/payment');
      } else setError(data.message);
    } catch (err) { setError(err.response?.data?.message || 'Connection error. Please try again.'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 24px 40px' }}>
      <div style={{ background: 'var(--bg-card)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 16, padding: 48, width: '100%', maxWidth: 580 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}><Logo size={40} /></div>
          <h1 style={{ fontSize: 22, fontFamily: 'Sora', fontWeight: 700, marginBottom: 8, color: '#fff' }}>Create Account</h1>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14 }}>Join MS Reach and grow your business</p>
        </div>

        {error && <div style={{ background: 'rgba(255,68,68,0.1)', border: '1px solid rgba(255,68,68,0.3)', color: '#ff6b6b', padding: '12px 16px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Input label="Full Name *" value={form.name} onChange={e => set('name', e.target.value)} placeholder="Your full name" required />
            <Input label="Company Name" value={form.company_name} onChange={e => set('company_name', e.target.value)} placeholder="Company name" />
            <Input label="Email *" type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="your@email.com" required />
            <Input label="Phone *" value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="+91 9876543210" required />
            <Input label="Password *" type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder="Min 6 characters" required />
            <Input label="Confirm Password *" type="password" value={form.confirm_password} onChange={e => set('confirm_password', e.target.value)} placeholder="Repeat password" required />
          </div>

          <Input label="Address" value={form.address} onChange={e => set('address', e.target.value)} placeholder="Your address" />

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Select label="State *" value={form.state} onChange={e => set('state', e.target.value)} options={STATES} required />
            <Input label="GST Number (Optional)" value={form.gstin} onChange={e => set('gstin', e.target.value)} placeholder="22AAAAA0000A1Z5" />
            <Select label="Plan *" value={form.plan_id} onChange={e => set('plan_id', e.target.value)} options={PLANS} required />
            <Select label="Billing Cycle" value={form.billing_cycle} onChange={e => set('billing_cycle', e.target.value)} options={[{ value: 'monthly', label: 'Monthly' }, { value: 'yearly', label: 'Yearly (Save 20%)' }]} />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.6)', marginBottom: 8, fontWeight: 500 }}>Currency</label>
            <div style={{ display: 'flex', gap: 16 }}>
              {[['INR', '₹ INR (India)'], ['USD', '$ USD (International)']].map(([c, l]) => (
                <label key={c} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14, color: 'rgba(255,255,255,0.7)' }}>
                  <input type="radio" name="currency" value={c} checked={form.currency === c} onChange={() => set('currency', c)} /> {l}
                </label>
              ))}
            </div>
          </div>

          {/* Price breakdown */}
          {price && (
            <div style={{ background: 'rgba(0,231,76,0.05)', border: '1px solid rgba(0,231,76,0.15)', borderRadius: 10, padding: 16, marginBottom: 16 }}>
              {[['Plan Amount', `${price.sym}${price.amount.toLocaleString()}`], price.gst > 0 ? [price.gstLabel, `${price.sym}${price.gst.toFixed(2)}`] : null, ['Total Payable', `${price.sym}${price.total.toFixed(2)}`]].filter(Boolean).map(([k, v], i, arr) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: i < arr.length - 1 ? '1px solid rgba(255,255,255,0.06)' : 'none' }}>
                  <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)' }}>{k}</span>
                  <span style={{ fontSize: i === arr.length - 1 ? 16 : 13, fontWeight: i === arr.length - 1 ? 700 : 500, color: i === arr.length - 1 ? 'var(--green)' : '#fff' }}>{v}</span>
                </div>
              ))}
            </div>
          )}

          <Btn type="submit" disabled={loading} full size="lg">
            {loading ? 'Creating account...' : 'Create Account & Proceed to Payment →'}
          </Btn>
        </form>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'rgba(255,255,255,0.4)' }}>
          Already have an account? <Link to="/login" style={{ color: 'var(--green)' }}>Sign in</Link>
        </div>
      </div>
    </div>
  );
}